import React from "react";
import { physicsCalculators_Fr } from "../ConstantsPhysicsCalculator";

function MainCalculatorsList() {
  let calculatorsList = physicsCalculators_Fr;
  let calculatorName = "Calculatrices de Physique";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.filter(item => item.showMain).slice(0, 6).map((item, index) =>
            (
              <li key={index}>
                <a href={item.link} className="item-link">
                  {item.name}
                </a>
              </li>
            )
          )}
        </ul>
        <div style={{ textAlign: "center" }}>
          <a
            className="btn btn-success"
            style={{ width: "90%" }}
            href={"/fr/physics-calculators/"}
          >
            Plus
          </a>
          <hr />
        </div>
      </div>
    </div>
  );
}

export default MainCalculatorsList;
